import React from 'react'
import { CardAuthor } from 'modules/common/components/ui/Card'

const ProductFooter = (props) => {
  const {
    image,
    profile_banner,
    label,
    place,
  } = props
  if (!label) {
    return null
  }
  const imageSrc = image instanceof Array && image.length > 0 ? image[0].formatted_medium : (profile_banner instanceof Array && profile_banner.length > 0 ? profile_banner[0].formatted_medium : undefined);
  return (
    <CardAuthor>
      { imageSrc && <span className="card--author-image" style={ {backgroundImage: `url(${imageSrc})`} } /> }
      <span className="card--author">
        <b className="card--author-name">{ label }</b><br />
        { place && <span className="card--author-place">{ place }</span> }
      </span>
    </CardAuthor>
  )
}

export default ProductFooter



// WEBPACK FOOTER //
// ./src/modules/search/components/ProductFooter.js